import type { Media, VideoContentObject } from 'models';
import { VideoDetailArchivedHeader } from './video-detail-archived-header';
import { VideoDetailDraftHeader } from './video-detail-draft-header';
import { VideoPublishedHeader } from './video-publish-header';

type P = {
  navigateToVideoList: () => Promise<void>;
  trailerData?: Media;
  videoContentObject: VideoContentObject;
};

// TODO: Maybe change in `Archived` and `Published` props `trailerData` and `fullData` to required
const VideoDetailHeader = ({ navigateToVideoList, trailerData, videoContentObject }: P) => {
  switch (videoContentObject.video.status) {
    case 'archived':
      return <VideoDetailArchivedHeader trailerData={trailerData} videoContentObject={videoContentObject} />;
    case 'draft':
      return (
        <VideoDetailDraftHeader
          onVideoDeleted={navigateToVideoList}
          trailerData={trailerData}
          videoContentObject={videoContentObject}
        />
      );
    case 'published':
      return <VideoPublishedHeader trailerData={trailerData} videoContentObject={videoContentObject} />;
  }
};

export default VideoDetailHeader;
